import React from 'react';
import { browserHistory } from 'react-router';
import { OrderItem } from 'swag-client-common/components/partials/cart/cart-item';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import { instantScrollTop } from 'swag-client-common/utils/tricks';
import { DesignUploadMode } from 'swag-common/interfaces';
import { checkIsMoreThanOneItemWithSimilarKey } from 'swag-common/utils/items/is-more-than-one-item-with-similar-key.util';
import { hasSplitShippedToInventory } from 'swag-common/utils/items/has-split-shipped-to-inventory';
import { Button } from '../../../../../../../common/components/ui/button';
import { getImageOfItem, isItemSizeEditable } from '../../../../../../redux/cart/cart.utils';
import { isRenderAsInventoryItems } from '../../../../../../redux/cart/order-item-list.utils-other';
import BoxOrderItemList from '../box-order-item-list';
import { InventoryOrderItemList } from '../inventory-order-item-list';
import ItemsBlockWrapper from '../items-block-wrapper';
import RelatedOrderItemList from '../related-order-item-list';
import { canContinueShopping } from './order-item-list-other.utils';
import classes from './order-item-list.scss';
import { buttonType, setWithBorderFlag } from './order-item-list.utils';
const OrderItemList = ({
  items,
  onMoveToDraft,
  onRemoveItem,
  onEditRequest,
  onSizeClick,
  onEditSizeOfSample,
  onClickMockup,
  onShareClick,
  onProductionTimeClick,
  onQuantityClick,
  onProductionTimeChange,
  isLoading,
  selectedItem,
  isResellerBuildCartMode,
  isPreBuiltLimitedCart,
  isResellerInOrderCreationMode
}) => {
  const handleContinueShopping = () => {
    browserHistory.push(APP_ROUTES.ALL_SWAG);
    instantScrollTop();
  };
  return /*#__PURE__*/React.createElement("div", {
    className: classes.orderItem,
    id: "cart"
  }, items.map((item, index) => {
    var _item$0$prod;
    const isArray = Array.isArray(item);
    const isRelated = isArray && checkIsMoreThanOneItemWithSimilarKey(item, 'asRelatedItemId');
    const isBox = isArray && checkIsMoreThanOneItemWithSimilarKey(item, 'boxItemsId');
    const isSplitShippedToInventory = hasSplitShippedToInventory(item);
    const isToInventory = isRenderAsInventoryItems(isBox, item) || isSplitShippedToInventory;
    if (isToInventory) {
      return /*#__PURE__*/React.createElement(InventoryOrderItemList, {
        items: item,
        key: item[0]._id,
        isLoading: isLoading,
        isSavedForLater: false,
        isPreBuiltLimitedCart: isPreBuiltLimitedCart,
        selectedItem: selectedItem,
        onSizeClick: onSizeClick,
        onRemoveItem: onRemoveItem,
        onShareClick: onShareClick,
        onMoveToDraft: onMoveToDraft,
        onClickMockup: onClickMockup,
        onEditRequest: onEditRequest,
        onQuantityClick: onQuantityClick,
        onEditSizeOfSample: onEditSizeOfSample,
        onProductionTimeClick: onProductionTimeClick,
        onProductionTimeChange: onProductionTimeChange
      });
    }
    if (isBox) {
      return /*#__PURE__*/React.createElement(ItemsBlockWrapper, {
        withMarginBottom: true,
        withShadow: true,
        isLastItem: items.length - 1 === index
      }, /*#__PURE__*/React.createElement(BoxOrderItemList, {
        isCart: true,
        items: item,
        item: item[0],
        key: item[0]._id,
        isLoading: isLoading,
        selectedItem: selectedItem,
        onSizeClick: onSizeClick,
        onRemoveItem: onRemoveItem,
        onShareClick: onShareClick,
        onMoveToDraft: onMoveToDraft,
        onClickMockup: onClickMockup,
        onEditRequest: onEditRequest,
        onQuantityClick: onQuantityClick,
        onEditSizeOfSample: onEditSizeOfSample,
        onProductionTimeClick: onProductionTimeClick,
        onProductionTimeChange: onProductionTimeChange,
        onSampleClick: () => ({})
      }));
    }
    if (isRelated) {
      return /*#__PURE__*/React.createElement(ItemsBlockWrapper, {
        key: item[0]._id,
        withMarginBottom: true,
        withShadow: true,
        isLastItem: items.length - 1 === index
      }, /*#__PURE__*/React.createElement(RelatedOrderItemList, {
        isCart: true,
        isPreBuiltLimitedCart: isPreBuiltLimitedCart,
        items: item,
        isLoading: isLoading,
        selectedItem: selectedItem,
        onSizeClick: onSizeClick,
        onRemoveItem: onRemoveItem,
        onShareClick: onShareClick,
        onMoveToDraft: onMoveToDraft,
        onClickMockup: onClickMockup,
        onEditRequest: onEditRequest,
        onQuantityClick: onQuantityClick,
        onEditSizeOfSample: onEditSizeOfSample,
        onProductionTimeClick: onProductionTimeClick,
        onProductionTimeChange: onProductionTimeChange
      }));
    }
    const designUploadMode = (_item$0$prod = item[0].prod) === null || _item$0$prod === void 0 ? void 0 : _item$0$prod.designUploadMode;
    return item.map(i => {
      const isPlainCard = item.length === 1;
      return /*#__PURE__*/React.createElement(ItemsBlockWrapper, {
        withMarginBottom: true,
        withShadow: true,
        key: item[0]._id,
        withBorder: setWithBorderFlag(items.length, index),
        isLastItem: items.length - 1 === index,
        isPlainCard: isPlainCard
      }, /*#__PURE__*/React.createElement(OrderItem, {
        index: index,
        item: i,
        selectedItem: selectedItem,
        itemLogoSrc: getImageOfItem(i),
        isSizeEditable: isItemSizeEditable(i),
        isFullDesign: designUploadMode === DesignUploadMode.fullDesign,
        isBoxProduct: designUploadMode === DesignUploadMode.box,
        isPlainCard: isPlainCard,
        removeItem: onRemoveItem,
        onSizeClick: onSizeClick,
        moveToDraft: onMoveToDraft,
        onShareClick: onShareClick,
        onClickMockup: onClickMockup,
        onEditRequest: onEditRequest,
        onQuantityClick: onQuantityClick,
        onEditSizeOfSample: onEditSizeOfSample,
        onProductionTimeClick: onProductionTimeClick,
        onProductionTimeChange: onProductionTimeChange
      }));
    });
  }), canContinueShopping({
    itemsLength: items.length,
    isPreBuiltLimitedCart,
    isResellerInOrderCreationMode
  }) && /*#__PURE__*/React.createElement("div", {
    className: classes.buttonLink
  }, /*#__PURE__*/React.createElement(Button, {
    onClick: handleContinueShopping,
    dataButton: "Shop Products",
    type: buttonType,
    size: "small",
    className: classes.button
  }, isResellerBuildCartMode ? 'Add products' : 'Continue Shopping')));
};
export { OrderItemList };